import { render, staticRenderFns } from "./CatalogProductTable.vue?vue&type=template&id=e266dcde"
import script from "./CatalogProductTable.vue?vue&type=script&lang=ts"
export * from "./CatalogProductTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports